import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ChevronRight, Home } from 'lucide-react';
import { SEO_CONFIG, getFullUrl } from '../../config/seo';

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Define breadcrumb names
  const breadcrumbNames = {
    'videos': 'KS × TCE Videos',
    'kundli-calculator': 'Kundli Calculator',
    'moon-sign-calculator': 'Moon Sign Calculator',
    'lagna-calculator': 'Lagna Calculator',
    'numerology-calculator': 'Numerology Calculator',
    'life-path-calculator': 'Life Path Calculator',
    'name-numerology': 'Name Numerology',
    'features': 'Features',
    'blog': 'Blog',
    'faq': 'FAQ',
    'privacy-policy': 'Privacy Policy',
    'terms-of-service': 'Terms of Service',
    'app': 'Astrology App'
  };

  // Don't show breadcrumbs on home page
  if (pathnames.length === 0) return null;

  // Generate BreadcrumbList structured data
  const breadcrumbItems = [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": SEO_CONFIG.baseUrl
    },
    ...pathnames.map((name, index) => {
      const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
      const displayName = breadcrumbNames[name] || name.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
      return {
        "@type": "ListItem",
        "position": index + 2,
        "name": displayName,
        "item": getFullUrl(routeTo)
      };
    })
  ];

  const breadcrumbStructuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbItems
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbStructuredData)}
        </script>
      </Helmet>
      <nav className="bg-white/50 backdrop-blur-sm border-b border-saffron-100">
      <div className="container mx-auto px-4 py-3">
        <ol className="flex items-center space-x-2 text-sm">
          <li>
            <Link 
              to="/" 
              className="flex items-center text-saffron-600 hover:text-saffron-800 transition-colors"
            >
              <Home className="w-4 h-4 mr-1" />
              <span>Home</span>
            </Link>
          </li>
          
          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            const displayName = breadcrumbNames[name] || name.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

            return (
              <li key={name} className="flex items-center">
                <ChevronRight className="w-4 h-4 text-saffron-400 mx-2" />
                {isLast ? (
                  <span className="text-saffron-800 font-medium">{displayName}</span>
                ) : (
                  <Link 
                    to={routeTo}
                    className="text-saffron-600 hover:text-saffron-800 transition-colors"
                  >
                    {displayName}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
    </>
  );
};

export default Breadcrumbs;
